import React from 'react';
import type { PuTreatmentVideo } from '../../patient-urgency/types';
import { Icon } from '../Icon/Icon';
import { cn } from '../../lib/cn';
import { puMono } from './puClasses';

export interface PuVideoPlaceholderProps {
  video: PuTreatmentVideo | null;
}

export function PuVideoPlaceholder({ video }: PuVideoPlaceholderProps) {
  if (!video) return null;

  return (
    <button
      type="button"
      onClick={(e) => e.preventDefault()}
      aria-label={`Play video: ${video.title}`}
      className="relative block w-full cursor-pointer overflow-hidden rounded-[var(--r-md)] border-0 p-0 shadow-[var(--sh-1)]"
      style={{ aspectRatio: '16 / 9', background: 'var(--ink-0)' }}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at 28% 36%, color-mix(in srgb, var(--ai-3) 34%, transparent), transparent 60%), radial-gradient(ellipse at 72% 64%, color-mix(in srgb, var(--ai-5) 32%, transparent), transparent 60%), linear-gradient(135deg, #1d1d1f, #2a2a2e)',
        }}
      />
      <div
        className="absolute left-1/2 top-1/2 inline-flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[rgba(255,255,255,0.96)]"
        style={{ width: 56, height: 56, boxShadow: '0 8px 24px rgba(0,0,0,0.32)' }}
      >
        <Icon kind="play" size={22} style={{ color: 'var(--ink-0)', marginLeft: 3 }} />
      </div>
      <div
        className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-2 px-3.5 pb-3 pt-5 text-white"
        style={{
          background: 'linear-gradient(180deg, transparent, rgba(0,0,0,0.7))',
        }}
      >
        <span className="text-left text-[13.5px] font-semibold tracking-[-0.005em]">{video.title}</span>
        <span
          className={cn(puMono, 'shrink-0 rounded px-1.5 py-0.5 text-[11px] font-medium')}
          style={{ background: 'rgba(0,0,0,0.55)' }}
        >
          {video.duration}
        </span>
      </div>
    </button>
  );
}
